import React from 'react';
import { useRightColumnContext } from 'Context/RightColumnContext';
import WhatIfClientScenarioDetails from 'Components/ComponentLibrary/Organisms/WhatIfClientScenarioDetails';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const useStyles = makeStyles(() => ({
  paper: {
    overflow: 'hidden',
  },
}));

const Scenario = () => {
  const classes = useStyles();
  const { rightColumnCollection } = useRightColumnContext();
  const [scenarioResource] = rightColumnCollection;

  return (
    <Paper
      className={classes.paper}
      variant={'outlined'}
      rounded
    >
      <WhatIfClientScenarioDetails
        rounded
        facetPlanClientViewCollection={rightColumnCollection}
        facetPlanClientViewResource={scenarioResource}
      />
    </Paper>
  );
};

export default Scenario;
